var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-main" },
    [
      _c(
        "v-app-bar",
        {
          class: { "header-mobile": _vm.mobile },
          attrs: {
            color: _vm.headerNavColor,
            dark: "",
            fixed: "",
            app: "",
            "clipped-right": "",
          },
        },
        [
          _c("portal-target", { attrs: { name: "header-left" } }, [
            _c(
              "div",
              { staticClass: "d-flex align-center minus-left" },
              [
                _vm.user && _vm.user != null && _vm.user.isGuestExamOnly
                  ? [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mk-0",
                          attrs: { icon: "" },
                          on: { click: _vm.toExamShow },
                        },
                        [_c("v-icon", [_vm._v("keyboard_arrow_left")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-toolbar-title",
                        {
                          class: { "ps-0": _vm.mobile },
                          style: { color: _vm.headerNavTextColor },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.headerTitle) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  : [
                      _c("v-app-bar-nav-icon", {
                        style: _vm.hamburgerColor,
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.drawer = !_vm.drawer
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.mobile
                        ? [
                            _c(
                              "span",
                              { style: { color: _vm.headerNavTextColor } },
                              [_vm._v(_vm._s(_vm.pageTitle))]
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass: "header-title",
                          class: { "m-0": true, "ps-0": _vm.mobile },
                        },
                        [
                          _c("div", { staticClass: "d-flex align-center" }, [
                            !_vm.mobile
                              ? _c(
                                  "div",
                                  { staticClass: "d-flex ms-4" },
                                  [
                                    _vm._l(_vm.menus, function (menu) {
                                      return [
                                        menu.kbn == "MENU_KBN_MENU"
                                          ? [
                                              _c(
                                                "v-list-group",
                                                {
                                                  key: menu.url,
                                                  attrs: { "no-action": "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              "v-list-item-content",
                                                              {
                                                                style: {
                                                                  color:
                                                                    _vm.headerNavTextColor,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "menu-view-name",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          menu.viewName
                                                                        ) +
                                                                        "\n                          "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "sub-menu p-2",
                                                    },
                                                    _vm._l(
                                                      menu.menuItems,
                                                      function (menuItem) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: menuItem.url,
                                                            staticClass:
                                                              "cursor-pointer mt-2",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.toMenu(
                                                                  menuItem
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-title",
                                                              {
                                                                staticClass:
                                                                  "menu-view-name",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      menuItem.viewName
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "v-list-item",
                                                {
                                                  key: menu.url,
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toMenu(menu)
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-content",
                                                    {
                                                      style: {
                                                        color:
                                                          _vm.headerNavTextColor,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        {
                                                          staticClass:
                                                            "menu-view-name",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                menu.viewName
                                                              ) +
                                                              "\n                        "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                      ]
                                    }),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ],
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("portal-target", { attrs: { name: "header-center" } }, [
            _vm.mobile
              ? _c(
                  "div",
                  { staticClass: "d-flex align-center" },
                  [
                    _c("HeaderNotification", {
                      attrs: { colorNotiIcon: _vm.headerNavTextColor },
                    }),
                    _vm._v(" "),
                    _vm.cartItemCount > 0
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "position-relative mx-2",
                            attrs: { icon: "" },
                            on: { click: _vm.goToCart },
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { color: _vm.headerNavTextColor } },
                              [_vm._v("mdi-cart")]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "cart-badge" }, [
                              _vm._v(_vm._s(_vm.cartItemCount)),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("HeaderUser"),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "d-flex align-center" },
                  [
                    _c("HeaderNotification", {
                      attrs: { colorNotiIcon: _vm.headerNavTextColor },
                    }),
                    _vm._v(" "),
                    _vm.cartItemCount > 0
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "position-relative mx-2",
                            attrs: { icon: "" },
                            on: { click: _vm.goToCart },
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { color: _vm.headerNavTextColor } },
                              [_vm._v("mdi-cart")]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "cart-badge" }, [
                              _vm._v(_vm._s(_vm.cartItemCount)),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("HeaderUser"),
                  ],
                  1
                ),
          ]),
          _vm._v(" "),
          _c("portal-target", { attrs: { name: "header-right" } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "portal-target",
        { attrs: { name: "header-left-drawer" } },
        [
          _vm.mobile
            ? _c("HeaderLeftMenuMobile", {
                model: {
                  value: _vm.drawer,
                  callback: function ($$v) {
                    _vm.drawer = $$v
                  },
                  expression: "drawer",
                },
              })
            : _c("HeaderLeftMenuWeb", {
                model: {
                  value: _vm.drawer,
                  callback: function ($$v) {
                    _vm.drawer = $$v
                  },
                  expression: "drawer",
                },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "header-right-drawer" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }